import axios from 'axios';

import {
  axiosHeader,
  axiosHeaderV2,
  getV1RootUrl,
  getV2RootUrl,
  publicAxiosHeaderV2,
  publicAxiosHeader
} from 'common/helpers/apiHelper';
import { customerId as getCustomerId } from 'common/helpers/tokenHelper';

export const getCustomer = () =>
  axios.get(`${getV2RootUrl()}/customer/self`, axiosHeaderV2());

export const loginCustomer = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/login`,
    loginObject,
    publicAxiosHeader()
  );

export const logoutCustomer = () =>
  axios.post(`${getV1RootUrl()}/customer/logout`, {}, axiosHeader());

export const unsubscribeCustomer = (customerId, payload) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}/unsubscribe`,
    payload,
    publicAxiosHeaderV2()
  );

export const fbLoginOrCreateCustomer = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/facebook-login-or-create`,
    loginObject,
    publicAxiosHeader()
  );

export const googleLoginOrCreateCustomer = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/google-login-or-create`,
    loginObject,
    publicAxiosHeader()
  );

export const validateMagicLinkId = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/magic-link-login`,
    loginObject,
    publicAxiosHeader()
  );

export const validateAccountActivationId = (loginObject) =>
  axios.post(
    `${getV1RootUrl()}/customer/account-activation`,
    loginObject,
    publicAxiosHeader()
  );

export const validateResetPasswordId = (data) =>
  axios.post(
    `${getV1RootUrl()}/customer/reset-password-login`,
    data,
    publicAxiosHeader()
  );

export const addCustomer = (customer) =>
  axios.post(
    `${getV2RootUrl()}/customer/for-web`,
    customer,
    publicAxiosHeaderV2()
  );

export const editCustomer = (customerId, params) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId}`,
    params,
    axiosHeaderV2()
  );

export const editCustomerPassword = (customerId, params) =>
  axios.put(
    `${getV1RootUrl()}/customer/${customerId}/password`,
    params,
    axiosHeader()
  );

export const forgotPassword = (data) =>
  axios.post(
    `${getV2RootUrl()}/customer/generate-reset-password-link`,
    data,
    publicAxiosHeaderV2()
  );

export const magicLink = (data) =>
  axios.post(
    `${getV1RootUrl()}/customer/generate-magic-link`,
    data,
    publicAxiosHeader()
  );

export const resetPassword = (data) =>
  axios.post(
    `${getV1RootUrl()}/customer/reset-password`,
    data,
    publicAxiosHeader()
  );

export const deleteCustomer = () =>
  axios.delete(`${getV1RootUrl()}/customer/${getCustomerId()}`, axiosHeader());
